module.exports = ".section {\n  background-color: var(--xiobit-black-color); }\n"